import React, { useEffect, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import styled from 'styled-components';
import ko from 'date-fns/locale/ko';

interface tabType {
  id: number;
  tab: string;
}
type Props = {
  type: string;
  openPathLog?: any;
  changeStartDate?: any;
  changeEndDate?: any;
  resetToday?:any;
  dateTabContentData?: tabType[];
  maxDate?: Date;
};
let dateTabContent = [
  {
    id: 0,
    tab: '오늘',
  },
  {
    id: 1,
    tab: '어제',
  },
  {
    id: 2,
    tab: '날짜 선택',
  },
];

const useTabs = (initialTabs: tabType[]) => {
  const [contentIndex, setContentIndex] = useState<number>(0);

  const activateTab = (index: number) => {
    setContentIndex(index);
  };
  return {
    contentItem: initialTabs[contentIndex],
    contentChange: activateTab,
    activeIndex: contentIndex,
  };
};

const DateTab = ({ type, openPathLog, changeStartDate, changeEndDate,resetToday, dateTabContentData = dateTabContent, maxDate }: Props) => {
  dateTabContent = dateTabContentData;

  const getToday = () => {
    const today = maxDate ? maxDate : new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  };

  const getYesterday = () => {
    const yesterday = getToday();
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday;
  };

  const [startDate, setStartDate] = useState<Date | null>(getToday());
  const [endDate, setEndDate] = useState<Date | null>(getToday());

  const { contentItem: dateContentItem, contentChange: dateContentChange } =
    useTabs(dateTabContentData);

  const tabClick = (item: tabType, index: number) => {
    dateContentChange(index);
    if (item.id === 0) { // 오늘
      const today = getToday();
      setStartDate(today);
      setEndDate(today);
      if (openPathLog) openPathLog(today, today);
      if (changeStartDate) changeStartDate(today);
      if (changeEndDate) changeEndDate(today);
    } else if (item.id === 1) { // 어제
      const yesterday = getYesterday();
      setStartDate(yesterday);
      setEndDate(yesterday);
      if (openPathLog) openPathLog(yesterday, yesterday);
      if (changeStartDate) changeStartDate(yesterday);
      if (changeEndDate) changeEndDate(yesterday);
    }
  };
  const handleDateChange = (dates: [Date | null, Date | null]) => {
    setStartDate(dates[0]);
    setEndDate(dates[1]);
  };
  useEffect(() => {
    dateContentChange(0);
    setStartDate(getToday());
    setEndDate(getToday());
  }, [resetToday]);
  return (
    <Style>
      <div className="dateTabWrap">
        {dateTabContent.map((section, index) => (
          <button
            key={'dateButtons-' + index.toString()}
            onClick={() => tabClick(section, index)}
            className={dateContentItem.id === section.id ? 'tab active' : 'tab'}>
            <h2>{section.tab}</h2>
          </button>
        ))}
        {dateContentItem.id === 2 && (
          <div className="calendarWrap">
            <label htmlFor="startDatePicker" className="calendarContainer">
              {type === 'oneDay' ? (
                <ReactDatePicker
                  showIcon
                  selected={startDate}
                  onChange={(date) => {
                    setStartDate(date);
                    setEndDate(date);
                    if (openPathLog) openPathLog(date, date);
                    if (changeStartDate) changeStartDate(date);
                    if (changeEndDate) changeEndDate(date);
                  }}
                  dateFormat="yyyy-MM-dd"
                  locale={ko}
                  onFocus={(e) => {
                    e.preventDefault();
                    e.target.blur();
                  }}
                  className="datePicker"
                  maxDate={maxDate}
                />
              ) : (
                <ReactDatePicker
                  id={'startDatePicker'}
                  className="datePicker"
                  selectsRange={true}
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => handleDateChange(update)}
                  dateFormat="yyyy-MM-dd"
                  isClearable={false}
                  locale={ko}
                  disabledKeyboardNavigation={true}
                  shouldCloseOnSelect={false}
                  onFocus={(e) => {
                    e.preventDefault();
                    e.target.blur();
                  }}
                  maxDate={maxDate}
                />
              )}
            </label>
          </div>
        )}
      </div>
    </Style>
  );
};

export default DateTab;
const Style = styled.div`
  /* dateTabWrap */
  .dateTabWrap {
    display: flex;
    justify-content: flex-start;
    gap: 10px;

    button {
      padding: 6px 14px;
      border: 1px solid #aaa;
      background: none;
      font-size: 16px;
      font-weight: 500;
      border-radius: 4px;
      color: #aaa;
      cursor: pointer;
    }
    button.active {
      background: #000;
      border: 1px solid #000;
      color: #fff;
      font-weight: 600;
      h2 {
        color: #fff;
      }
    }
  }

  /* calendarWrap */
  .calendarContainer input {
    cursor: pointer;
    width: 150px;
    background: none;
    border-radius: 4px;
    border: 1px solid #000;
    padding: 7px 7px 7px 33px;
  }
`;
